import React, { Fragment } from 'react';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';

const ReactTableActionsDiagnostic = ({data, Callback }) => {
    
    return (<Fragment>
              <td role="cell">
                <IconButton 
                  aria-label="add"
                  onClick={()=>{
                    console.log(data.data.original);
                    Callback(data.data.original);
                  }}
                >
                  <AddBoxIcon />
                </IconButton>
              </td>
            </Fragment>)
  }

export default ReactTableActionsDiagnostic; 